import Linkify from 'linkify-react'
import type { IntermediateRepresentation } from 'linkifyjs'
import React from 'react'
import styled from 'styled-components'
import { easeInOutTransition } from '~/components/CommonStyles'

const StyledLink = styled.a`
  text-decoration: underline;
  color: var(--chakra-colors-fg-default);
  ${easeInOutTransition};
  &:hover {
    color: var(--chakra-colors-brand-emphasized);
  }
`

const renderLink = ({ attributes, content }: IntermediateRepresentation) => {
  const { href } = attributes
  return (
    <StyledLink href={href} target="_blank" rel="noopener noreferrer">
      {content}
    </StyledLink>
  )
}

const linkifyOptions = { render: renderLink }

interface LinkifyProps {
  children: React.ReactNode
}

const LinkifyWrapper: React.FC<LinkifyProps> = ({ children }) => {
  return <Linkify options={linkifyOptions}>{children}</Linkify>
}

export default LinkifyWrapper
